import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

export default function GuideScrollTop({ rootRef }) {
  const [visible, setVisible] = useState(false);
  const containers = useRef(new Set());
  useEffect(() => {
    const root = rootRef?.current;
    const tracked = containers.current;
    const isContent = element => element instanceof HTMLElement
      && !element.closest('nav, aside, textarea, [role="dialog"], [role="menu"], [role="listbox"]')
      && (element.closest('main, [data-public-page-content]') || element.querySelector('main, [data-public-page-content]'));
    const update = event => {
      const target = event?.target;
      if (isContent(target) && target.scrollTop > 0) tracked.add(target);
      for (const element of tracked) {
        if (!element.isConnected || element.scrollTop <= 0) tracked.delete(element);
      }
      setVisible(window.scrollY > 0 || tracked.size > 0);
    };
    // Account for restored scroll positions as well as new scroll events.
    root?.querySelectorAll('*').forEach(element => {
      if (element.scrollTop > 0 && isContent(element)) tracked.add(element);
    });
    update();
    window.addEventListener("scroll", update, { passive: true });
    root?.addEventListener("scroll", update, { capture: true, passive: true });
    return () => {
      window.removeEventListener("scroll", update);
      root?.removeEventListener("scroll", update, true);
      tracked.clear();
    };
  }, [rootRef]);
  if (!visible) return null;
  return <Tooltip title="Наверх">
    <IconButton aria-label="Наверх" onClick={() => {
      const options = { top: 0, behavior: window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" };
      window.scrollTo(options);
      containers.current.forEach(container => container.scrollTo(options));
    }}
      sx={{ position: "fixed", right: { xs: 16, sm: 24 }, bottom: "calc(24px + env(safe-area-inset-bottom, 0px))", zIndex: 1100, width: 48, height: 48, bgcolor: "var(--green-color)", color: "#fff", boxShadow: 3, "&:hover": { bgcolor: "var(--button-green-hover)" }, "&:active": { bgcolor: "var(--button-green-active)" },
        '@media (max-width:600px)': {
          bgcolor: '#FFFFFF', color: 'var(--green-color)', border: '1px solid rgba(60,44,19,0.16)',
          '&:hover': { bgcolor: '#F0F5F1' }, '&:active': { bgcolor: '#E7F0EB' },
          // A trip's section navigator already provides the mobile top action.
          'body:has([data-mobile-scroll-top]) &': { display: 'none' },
        },
      }}>
      <KeyboardArrowUpIcon />
    </IconButton>
  </Tooltip>;
}
